import { IonContent, IonPage } from '@ionic/react';

import logo from '@/assets/images/logo/logo-with-icon.png';
import { Padding, Promo } from '@/components/common';
import { Text } from '@/components/memo';

import './NoInternet.css';

const NoInternet: React.FC = () => {
  const copy = {
    promo: {
      header: (
        <>
          No <Text color="primary">internet</Text> connection!
        </>
      ),
      subHeader: 'Please check your connection and try again.'
    }
  };

  return (
    <IonPage id="no-internet">
      <IonContent scrollX={false} scrollY={false}>
        <Padding>
          <div className="no-internet__promo-container">
            <Promo
              image={logo}
              imageStyle={{ maxWidth: 192 }}
              header={copy.promo.header}
              subHeader={copy.promo.subHeader}
            />
          </div>
        </Padding>
      </IonContent>
    </IonPage>
  );
};

export default NoInternet;
